import * as type from './actionType.js'
//保存用户信息
export  const saveUserInfo = data=>{
    return {
        type:type.SAVEUSERINFO,
        payload:data
    }
}


// WEBPACK FOOTER //
// ./src/store/user/action.js